import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import BusinessQuoteTab from "./BusinessQuoteTab";
import PersonalFormTab from "./PersonalFormTab";
// import PackageTrackingForm from "../../utilcomponents/PackageTrackingForm";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import InboxIcon from "@mui/icons-material/MoveToInbox";
// import MailIcon from "@mui/icons-material/Mail";
// import NestedList from "./NestedList";
// import { Typography } from "@mui/material";
// import shipatlas from "../../assets/shipatlas.jpg";
// import Faq from "./Faq";

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}>
			{value === index && <Box sx={{ p: 1 }}>{children}</Box>}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

export default function QuoteFormTab() {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%" }}>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="basic tabs example">
					<Tab label="Business" {...a11yProps(0)} />
					<Tab label="Individual" {...a11yProps(1)} />
					{/* <Tab label="Item Three" {...a11yProps(2)} /> */}
				</Tabs>
			</Box>
			<CustomTabPanel value={value} index={0}>
				<Box sx={{ minWidth: "100%" }}>
					<BusinessQuoteTab />
				</Box>
				{/* <NestedList /> */}
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				<PersonalFormTab />
			</CustomTabPanel>
			{/* <CustomTabPanel value={value} index={2}>
                Item Three
            </CustomTabPanel> */}
		</Box>
	);
}
